import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is carried by an httpOnly `session_token` cookie (set by the backend on
// login/signup/session). `withCredentials` sends it automatically. The token is
// intentionally NOT stored in localStorage — that keeps it out of reach of XSS.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
